import type { TJSONSchema } from "@artifact-management/json-dynamic-form";
import { FormControl, FormControlLabel, FormHelperText, FormLabel, Radio, RadioGroup } from "@mui/material";
import { Controller, type FieldValues, type Path, type PathValue } from "react-hook-form";
import type { IFormGenInputProps } from "./index";
import { getFormGenEnumLabels, getFormGenEnumOptionKey, getFormGenEnumOptions } from "./logics";

export const FormGenInputRadio = <Schema extends TJSONSchema, T extends FieldValues>({
  control,
  uiSchemaElement,
  jsonSchemaElement,
  multiple,
  enumOptions,
}: IFormGenInputProps<Schema, T>) => {
  const options = getFormGenEnumOptions(enumOptions, getFormGenEnumLabels(jsonSchemaElement, multiple));
  return (
    <Controller
      control={control}
      name={uiSchemaElement.scope as unknown as Path<T>}
      defaultValue={"" as unknown as PathValue<T, Path<T>>}
      render={({ field, fieldState }) => (
        <FormControl error={Boolean(fieldState.error)} disabled={uiSchemaElement.disabled}>
          <FormLabel>{uiSchemaElement.label}</FormLabel>
          <RadioGroup
            row={uiSchemaElement.row ?? true}
            value={getFormGenEnumOptionKey(field.value)}
            onChange={(_, key) => field.onChange(options.find((option) => option.key === key)?.value ?? key)}
            onBlur={field.onBlur}
          >
            {options.map((option) => (
              <FormControlLabel key={option.key} value={option.key} control={<Radio />} label={option.label} />
            ))}
          </RadioGroup>
          {fieldState.error && <FormHelperText error>{fieldState.error.message}</FormHelperText>}
        </FormControl>
      )}
    />
  );
};
